export const ZohoBooksHealthCheckNotificationsType = {
  ZOHO_BOOKS_MANUAL_IMPORT_COMPLETED: 'ZOHO_BOOKS_MANUAL_IMPORT_COMPLETED',
};

export const ZohoBooksCheckNotificationsWithCriticalSeverityLevel: string[] =
  [];
